import intlTelInput from 'intl-tel-input';
import CheckoutForm from '../../../components/checkoutForm/scripts/index.js';
import DeliveryMethod from '../../../components/checkoutForm/scripts/deliveryMethods';
import {CheckoutTracking} from '../../../components/checkoutForm/scripts/tracking';
class Checkout {
  constructor(container) {
    this.container = container;
    if (!window.checkout) {
      window.checkout = {
        isFreeDeliveryApplied: false,
        totalPrice: null,
        paymentMethod: null, 
        discountAmountCombined: null,
        deliveryCode: null,
        deliveryMethod: null,
        deliveryPrice: null,
        manualDiscountCode: null,
        discountAmount: null,
        vatPrice: null,
        pickupPointsDeliveryMethods: [],
        giftCardCode: null,
        giftCardAmount: null,
        mediaTarget: null,
        subscriptionFreeShipping: false
      };
    }
    this.orderOverviews = this.container.querySelectorAll('.checkout-order__card');
    this.shopCurrency = Theme.settings.shop_currency;
    this.shopLocale = Theme.settings.shop_locale;
    this.countryIsoCode = Theme.settings.country_iso_code;
    this.phoneInput = document.querySelector('#checkout-phone');
    this.setupTracking();
    console.log('Checkout constructor', this.container);
    
    if (!this.container) {
      return;
    }
    this.checkoutForm =  new CheckoutForm(this.container);
    this.discountCodeInstance = this.checkoutForm.getDiscountInstance();
    this.init();
  }

  init() {
    this.applySubscriptionFreeShipping();
    this.setupOrderOverviewToggle();
    this.setupPaymentMethods();
    this.setupPolicyModals();
    if(this.orderOverviews){
      this.orderOverviews.forEach(orderOverview => {
        this.setupOrderOverview(null, orderOverview);
      });
    }
    this.filterPaymentMethodsByLimit();
    this.initIntlTelInput();
    this.initTooltip();


    new DeliveryMethod(this.container);
    const handleOrderEvent = (event) => {
      if(event.type === 'free-delivery:applied'){
        if(this.orderOverviews){
          this.orderOverviews.forEach(orderOverview => {
            this.setupOrderOverview(null, orderOverview);
          });
        }
        this.filterPaymentMethodsByLimit();
      }
      else if(event.type === 'checkout:updated'){
        const discountAmount = event?.detail?.discountAmount ?? window.checkout.discountAmountCombined ?? null;
        const discountAmountInLiveCartTotal = event?.detail?.discountAmountInLiveCartTotal ?? window.checkout.discountAmountInLiveCartTotal ?? 0;
        if(this.orderOverviews){
          this.orderOverviews.forEach(orderOverview => {
            this.setupOrderOverview(discountAmount, orderOverview, discountAmountInLiveCartTotal);
          });
        }
        this.filterPaymentMethodsByLimit();
      }
    };

    document.addEventListener('checkout:updated', handleOrderEvent);
    document.addEventListener('free-delivery:applied', handleOrderEvent);

    if (window.checkout.subscriptionFreeShipping) {
      document.dispatchEvent(new CustomEvent('free-delivery:applied', { detail: { freeDelivery: true } }));
    }
  }

  // Free shipping driven by a subscription variant's custom.free_shipping metafield
  // (exposed as data-item-free-shipping). Mirrors the free-shipping discount behaviour:
  // sets isFreeDeliveryApplied so totals show "Fri levering" and the delivery methods
  // render the price struck-through with "Fri levering" next to it.
  applySubscriptionFreeShipping() {
    const card = this.container.querySelector('.checkout-order__card[data-is-main="true"]')
      || this.container.querySelector('.checkout-order__card');
    if (!card) return;
    const hasFreeSubscription = [...card.querySelectorAll('.cart-line__item')].some(item =>
      item.dataset.itemSubscriptionProduct === 'true' && item.dataset.itemFreeShipping === 'true'
    );
    window.checkout.subscriptionFreeShipping = hasFreeSubscription;
    if (hasFreeSubscription) {
      window.checkout.isFreeDeliveryApplied = true;
    }
  }

  async setupPolicyModals() {
    const policyLinks = this.container.querySelectorAll('.site-policies a');
    if (!policyLinks.length) return;

    let modal = document.getElementById('policy-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'policy-modal';
      modal.className = 'policy-modal d-none';
      modal.innerHTML = `
        <div class="policy-modal__overlay"></div>
        <div class="policy-modal__content">
          <button class="policy-modal__close" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="policy-modal__body"></div>
        </div>
      `;
      document.body.appendChild(modal);
      const closeBtn = modal.querySelector('.policy-modal__close');
      const overlay = modal.querySelector('.policy-modal__overlay');
      
      const closeModal = () => {
        modal.classList.add('d-none');
        document.body.style.overflow = '';
      };

      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', closeModal);
      
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('d-none')) {
          closeModal();
        }
      });
    }

    policyLinks.forEach(link => {
      link.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        let termsOfTrade = false;
        const url = link.getAttribute('href');
        if(url){
          if(url.includes('/pages/handelsbetingelser') || url.includes('/pages/algemene-voorwaarden') || url.includes('/pages/tilaus-ja-toimitusehdot')){
            termsOfTrade = true;
          }
        }
        
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Failed to load policy');
          
          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          let content;
          if(termsOfTrade){
            content = doc.querySelector('#MainContent');
          }
          else {
            content = doc.querySelector('.rte') || 
            doc.querySelector('.page-content') || 
            doc.querySelector('main');
          }
          console.log("content", content)
          if (content) {
            modal.querySelector('.policy-modal__body').innerHTML = content.innerHTML;
            modal.classList.remove('d-none');
            document.body.style.overflow = 'hidden';
          } else {
            window.open(url, '_blank');
          }
        } catch (error) {
          console.error('Error loading policy:', error);
          window.open(url, '_blank');
        }
      });
    });
  }

  setupOrderOverviewToggle() {
    const toggleHeader = this.container.querySelector('.order-overview-toggle__header');
    const toggleContent = this.container.querySelector('.order-overview-toggle__content');
    
    if (toggleHeader && toggleContent) {
      const toggleArrow = toggleHeader.querySelector('.order-overview-toggle__arrow');
      toggleHeader.addEventListener('click', () => {
        toggleContent.classList.toggle('d-none');
        if (toggleArrow) {
          toggleArrow.classList.toggle('is-rotated');
        }
      });
    }
  }

  initIntlTelInput() {
    const iti = intlTelInput(this.phoneInput, {
      initialCountry:  this.countryIsoCode,
      countrySearch: false,
      autoPlaceholder: 'off',
      countryOrder: [this.countryIsoCode, 'se', 'no', 'fi', 'de', 'at', 'ch', 'it', 'fr', 'es', 'pt', 'nl', 'be', 'lu', 'ie', 'gb'],
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',
    });

    document.querySelector('#checkout-phone').addEventListener("countrychange", () => {
      const countryData = iti.getSelectedCountryData();
      const dialCode = countryData.dialCode;
      const country = countryData.name;
      const event = new CustomEvent('checkout:country-changed', {
        detail: {
          dialCode: dialCode,
          country: country
        }
      });
      document.dispatchEvent(event);
    })
  }

  initTooltip() {
    const tooltip = `
    <div class="phone-tooltip">
      <span class="phone-tooltip-question-mark">?</span>
      <span class="phone-tooltip-text">${Theme?.strings?.checkout_phone_tooltip}</span>
    </div> `;

    const itiContainer = this.container.querySelector('.iti__country-container');
    if(!itiContainer) return;
    itiContainer.insertAdjacentHTML('beforebegin', tooltip);
  }
  setupPaymentMethods() {
    const paymentMethods = this.container.querySelectorAll('input[name="payment-method"]');
    const paymentMethodItemsHeader = this.container.querySelectorAll('.payment-method-item .payment-method-header');
    const contentAreas = this.container.querySelectorAll('.payment-method-content');

    const activePaymentMethod = this.container.querySelector('input[name="payment-method"]:checked');
    if(!activePaymentMethod) return;

    const activePaymentMethodWrapper = activePaymentMethod.closest('.payment-method-item');
    if(!activePaymentMethodWrapper) return;

    if(activePaymentMethodWrapper){
      const paymentMethod = activePaymentMethodWrapper.getAttribute('data-api-payment-method');
      if(paymentMethod) window.checkout.paymentMethod = paymentMethod;
    }

    if(activePaymentMethod){
      const activePaymentMethodHeader = activePaymentMethod.closest('.payment-method-header');
      this.fillInPaymentMethodData(activePaymentMethodHeader);
    }

    this.onPaymentMethodChange(paymentMethods, paymentMethodItemsHeader, contentAreas);
  }

  filterPaymentMethodsByLimit() {
    const totalPrice = window.checkout?.totalPrice ?? 0;
    const allPaymentItems = this.container.querySelectorAll('.payment-method-item');
    const limitedItems = this.container.querySelectorAll('.payment-method-item[data-api-hide-after-limit-exceeded]');

    if(!allPaymentItems || !limitedItems) return;

    limitedItems.forEach((item) => {
      if(!item) return;
      const limitValueRaw = item?.dataset?.apiHideAfterLimitExceeded;
      if(!limitValueRaw) return;
      const limitValue = parseInt(limitValueRaw, 10);
      if (isNaN(limitValue)) return;

      const limitInCents = limitValue * 100;
      if(isNaN(limitInCents)) return;
      const shouldHide = totalPrice >= limitInCents;
      item.classList.toggle('is-hidden-by-limit', shouldHide);

      if (shouldHide) {
        const radio = item.querySelector('input[type="radio"]');
        if (radio && radio.checked) {
          const firstVisible = this.container.querySelector('.payment-method-item:not(.is-hidden-by-limit) input[type="radio"]');
          if (firstVisible) {
            firstVisible.checked = true;
            const header = firstVisible.closest('.payment-method-header');
            if (header) this.fillInPaymentMethodData(header);
            const wrapper = firstVisible.closest('.payment-method-item');
            if(!wrapper) return;
            const paymentMethod = wrapper.getAttribute('data-api-payment-method');
            if (paymentMethod) window.checkout.paymentMethod = paymentMethod;
            this.container.querySelectorAll('.payment-method-content').forEach(c => c.style.display = 'none');
            const contentId = firstVisible.value + '-content';
            if(!contentId) return;
            const content = document.getElementById(contentId);
            if (content) content.style.display = 'flex';
          }
        }
      }
    });

    const visibleItems = this.container.querySelectorAll('.payment-method-item:not(.is-hidden-by-limit)');
    allPaymentItems.forEach((item) => {
      item.classList.remove('is-first-visible', 'is-last-visible');
    });
    if (visibleItems.length > 0) {
      visibleItems[0].classList.add('is-first-visible');
      visibleItems[visibleItems.length - 1].classList.add('is-last-visible');
    }
  }

  onPaymentMethodChange(paymentMethods, paymentMethodItemsHeader, contentAreas) {
    if(!paymentMethods || !paymentMethodItemsHeader || !contentAreas) return;
    const outerThis = this;
      if (paymentMethods.length > 0) {
        paymentMethodItemsHeader.forEach(method => {
          method.addEventListener('click', function() {
            const groupWrapper = method.closest('.payment-method-item');
            if(!groupWrapper){
              console.warn("Payment method group wrapper not found")
              return;
            }
            const paymentMethod = groupWrapper.getAttribute('data-api-payment-method');
            if(paymentMethod) window.checkout.paymentMethod = paymentMethod;
            const input = groupWrapper.querySelector('input[type="radio"]');
            input.checked = true;
              contentAreas.forEach(content => {
                  content.style.display = 'none';
              });
              const selectedContent = document.getElementById(input.value + '-content');
              if (selectedContent) {
                  selectedContent.style.display = 'flex';
              }
              outerThis.fillInPaymentMethodData(method);
          });
      });
    }
  }
  fillInPaymentMethodData(paymentMethodHeader){
    const wrapper = paymentMethodHeader.closest('.payment-method-item');
    const apiCardTypeId = wrapper.dataset.apiCardTypeId;
    const apiPayGatewayCurrentCode = wrapper.dataset.apiPayGatewayCurrentCode;
    const apiPaymentMethod = wrapper.dataset.apiPaymentMethod;
    if(apiCardTypeId && apiPayGatewayCurrentCode && apiPaymentMethod){
      const apiGatewayCurrCodeInput = document.querySelector('#wellvita-payment-form input[name="APIPayGatewayCurrCode"]');
      const apiCardTypeIdInput = document.querySelector('#wellvita-payment-form input[name="APICardTypeID"]');
      const apiPaymentMethodInput = document.querySelector('#wellvita-payment-form input[name="APIPaymentMethod"]');
      if(apiGatewayCurrCodeInput && apiCardTypeIdInput && apiPaymentMethodInput){
        apiGatewayCurrCodeInput.setAttribute('value', apiPayGatewayCurrentCode);
        apiCardTypeIdInput.setAttribute('value', apiCardTypeId);
        apiPaymentMethodInput.setAttribute('value', apiPaymentMethod);
      }
    }

  }

  getDeliveryPrice(delivery) {
    const isFreeDeliveryApplied = window.checkout?.isFreeDeliveryApplied || false;
    if(isFreeDeliveryApplied) {
      this.applyFreeDelivery(delivery);
      return 0;
    }
    this.removeFreeDelivery(delivery);
    const deliveryPriceInput = this.container.querySelector('.delivery-method-item input[type=radio]:checked')
    let deliveryPrice = 0;
    if(deliveryPriceInput){
      const deliveryPriceWrapper = deliveryPriceInput.closest('.delivery-method-item')
      deliveryPrice = deliveryPriceWrapper.dataset.deliveryPrice;
    }
    return deliveryPrice;
  }

  setupOrderOverview(discountCodeAmoutAdjusted, orderOverview, manualDiscountInLiveCartTotal = 0) {
    const els = this.getOrderOverviewElements(orderOverview);
    if (!els) return;

    const { subtotal, delivery, discount, discountCode, total, cartLineItems, totalVat, globalVat } = els;

    const fsShip = parseFloat(window.checkout?.freeShippingDiscountAmount) || 0;
    const automaticDiscountAmount = parseFloat(window.checkout?.automaticDiscountAmount) || 0;
    const manualDiscountAmount = parseFloat(discountCodeAmoutAdjusted) || 0;
    // Split manual discount: portion already reflected in cart.total_price vs portion that isn't.
    // - Already in cart.total_price: codes applied via cart page (cart_level_discount_applications).
    // - Not in cart.total_price: codes applied on the checkout page via Storefront API only.
    const manualInLive = parseFloat(manualDiscountInLiveCartTotal) || 0;
    const manualNotInLive = Math.max(manualDiscountAmount - manualInLive, 0);
    const subtotalPriceRaw = parseFloat(subtotal.dataset.subtotalPrice) || 0;
    if (!subtotalPriceRaw) {
      console.error('Subtotal price not found', subtotal.dataset.subtotalPrice);
      return;
    }

    // subtotalPriceRaw (cart.total_price) reflects automatic discounts and any manual codes
    // already applied to the live cart, but NOT manual codes applied via Storefront API only.
    // fsShip is a free-shipping product discount we RELOCATE to the shipping line: add it back
    // here so the product shows at full price, and subtract it from the displayed delivery below.
    const priceBeforeAllDiscounts = subtotalPriceRaw + fsShip + automaticDiscountAmount + manualInLive;

    if (fsShip > 0 || automaticDiscountAmount > 0 || manualDiscountAmount > 0) {
      if (subtotal) {
        subtotal.innerText = Theme.Shopify.formatMoney(priceBeforeAllDiscounts, Theme.money_format);
      }
    }

    this.updateDiscountDisplay(null, discount, null, subtotalPriceRaw, manualDiscountAmount, automaticDiscountAmount);
    this.toggleDiscount(manualDiscountAmount, discountCode);

    // Full delivery price drives the TOTAL. fsShip is shown only as a reduction on the displayed
    // delivery line (and the delivery-method list) — the total already accounts for it because
    // fsShip was added back into the subtotal above, so it nets to zero in the total.
    const isFreeDeliveryApplied = window.checkout?.isFreeDeliveryApplied || false;
    const fullDeliveryPrice = parseFloat(this.getDeliveryPrice(delivery)) || 0;
    if (isFreeDeliveryApplied) {
      if (fullDeliveryPrice) delivery.innerText = Theme.Shopify.formatMoney(fullDeliveryPrice, Theme.money_format);
    } else {
      const displayedDelivery = Math.max(0, fullDeliveryPrice - fsShip);
      this.renderDeliveryPrice(delivery, fullDeliveryPrice, displayedDelivery, fsShip);
    }
    this.calculateTotalVAT(cartLineItems, totalVat, fullDeliveryPrice, globalVat);

    // subtotalPriceRaw already has automatic + manualInLive applied; subtract the
    // manual portion that ISN'T in cart.total_price (checkout-page-applied codes), then add delivery.
    const totalPrice = subtotalPriceRaw - manualNotInLive + fullDeliveryPrice;

    total.forEach(total => {
      const totalPriceNoCurrency = (parseFloat(totalPrice) / 100).toFixed(2).replace('.', ',');
      const formattedMoney = Theme.Shopify.formatMoney(totalPrice, Theme.money_format);
      total.innerText = formattedMoney;
      total.dataset.totalPriceFormattedNoCurrency = totalPriceNoCurrency;
      total.dataset.totalPriceFormatted = formattedMoney;
      total.dataset.totalPrice = totalPrice;
      window.checkout.totalPrice = totalPrice;
      this.updateOrderOverviewTotalPrice(formattedMoney, totalPrice);
    });
  }

  updateOrderOverviewTotalPrice(formattedMoney, totalPrice) {
    const orderOverviewHeader = document.querySelector('.order-overview-toggle__header');
    if(!orderOverviewHeader) return;
    const orderOverviewHeaderPriceEl = orderOverviewHeader.querySelector('[data-checkout-total]');
    if(!orderOverviewHeaderPriceEl) return;
    orderOverviewHeaderPriceEl.innerText = formattedMoney;
    orderOverviewHeaderPriceEl.dataset.totalPrice = totalPrice;
  }

  calculateTotalVAT(cartLineItems, totalVat, deliveryPrice, globalVat){
    if(!cartLineItems || !totalVat || !deliveryPrice || !globalVat) return;
    let vatPriceCombined = this.calculateLineItemsVAT(cartLineItems) + this.calculateDeliveryVAT(deliveryPrice, globalVat);
    const formattedVat = Theme.Shopify.formatMoney(vatPriceCombined, Theme.money_format);
    const totalVatTextCalculation = totalVat.querySelector('.vat_final_calculation');
    if(totalVatTextCalculation) totalVatTextCalculation.innerText = formattedVat;
    const totalVatWrapper = totalVat.closest('.checkout-order__total-item');
    if(totalVatWrapper) totalVatWrapper.classList.remove('d-none');
    window.checkout.vatPrice = vatPriceCombined;
  }
  calculateLineItemsVAT(cartLineItems){
    let lineItemsVat = 0;
    cartLineItems.forEach(item => {
      if(item.dataset.itemIsFree === 'true') return;
      const vat = item.dataset.itemProductVat;
      const vatNumber = parseFloat(vat);
      const priceRaw = item.dataset.itemOriginalUnitPriceRaw;
      const quantity = parseInt(item.dataset.itemQuantity, 10) || 1;
      const priceRawNumber = parseFloat(priceRaw) * quantity;
      if(isNaN(vatNumber) || isNaN(priceRawNumber)) return;
      const vatNumberCalc = (vatNumber + 100) / 100;
      const vatDiff = priceRawNumber / vatNumberCalc;
      const vatPrice = (priceRawNumber - vatDiff) ;
      lineItemsVat += vatPrice;
    });
    if(isNaN(lineItemsVat)) return 0;
    return lineItemsVat;
  }

  calculateDeliveryVAT(deliveryPrice, globalVat){
    if(!deliveryPrice || !globalVat) return 0;
    const deliveryPriceNumber = parseFloat(deliveryPrice);
    const globalVatNumber = parseFloat(globalVat);
    const globalVatNumberCalc = (globalVatNumber + 100) / 100;
    const deliveryVatDiff = deliveryPriceNumber / globalVatNumberCalc;
    const deliveryVatFinal = (deliveryPriceNumber - deliveryVatDiff) ;
    if(isNaN(deliveryVatFinal)) return 0;
    return deliveryVatFinal;
  }


updateTotalPriceDisplay(totalElements, subtotalPrice, deliveryPrice, discountCodeAmountAdjusted) {
  const finalTotal = discountCodeAmountAdjusted > 0
    ? subtotalPrice + deliveryPrice - discountCodeAmountAdjusted
    : subtotalPrice + deliveryPrice;

  const formatted = Theme.Shopify.formatMoney(finalTotal, Theme.money_format);

  totalElements.forEach(total => {
    total.innerText = formatted;
    total.dataset.totalPriceFormatted = formatted;
    total.dataset.totalPrice = finalTotal;
  });
}

  updateDiscountDisplay(originalPrice, discountElement, originalTotalPrice, subtotalPrice, discountCodeAmountAdjusted, automaticDiscountAmount = 0) {
    if (subtotalPrice < originalTotalPrice) {
      const wrapper = originalPrice.closest('.checkout-order__total-item');
      if (wrapper) wrapper.classList.remove('d-none');
    }
  
    let discountValue = originalTotalPrice - subtotalPrice;
    if (discountCodeAmountAdjusted > 0) {
      discountValue += parseFloat(discountCodeAmountAdjusted);
    }
    if(discountCodeAmountAdjusted === 0 || discountCodeAmountAdjusted === null){
      const discountElementWrapper = discountElement.closest('.checkout-order__total-item');
      if(discountElementWrapper) discountElementWrapper.classList.add('d-none');
    }
  
    if (discountValue > 0 && discountElement) {
      const wrapper = discountElement.closest('.checkout-order__total-item');
      if (wrapper) wrapper.classList.remove('d-none');
      discountElement.innerText = Theme.Shopify.formatMoney(discountValue, Theme.money_format);
    }
  };

  setOriginalPrice(originalPriceElement, cartLineItems) {
    let originalTotal = 0;
    cartLineItems.forEach(item => {
      originalTotal += parseFloat(item.getAttribute('data-item-original-total-price'));
    });
  
    originalPriceElement.innerText = Theme.Shopify.formatMoney(originalTotal, Theme.money_format);
    return originalTotal;
  }

  getOrderOverviewElements(orderOverview) {
    const container = orderOverview;
    const baseSelector = '.checkout-order__total';
    const originalPrice = container.querySelector(`${baseSelector} [data-checkout-original-price]`);
    const subtotal = container.querySelector(`${baseSelector} [data-checkout-subtotal]`);
    const delivery = container.querySelector(`${baseSelector} [data-checkout-delivery]`);
    const discount = container.querySelector(`${baseSelector} [data-checkout-discount]`);
    const discountCode = container.querySelector(`${baseSelector} [data-checkout-discount-code]`);
    const totalVat = container.querySelector(`${baseSelector} [data-checkout-total-vat]`);
    const globalVat = container.getAttribute('data-global-vat');
    const total = container.querySelectorAll('[data-checkout-total]');
    const cartLineItems = container.querySelectorAll(`.cart-line__items .cart-line__item`);
    if (!(originalPrice && subtotal && delivery && discountCode && total && cartLineItems.length && totalVat && globalVat)) {
      return null;
    }
  
    return { originalPrice, subtotal, delivery, discount, discountCode, total, cartLineItems, totalVat, globalVat };
  }

  // Render the order-summary delivery line with the free-shipping discount relocated onto it.
  // displayedDelivery = max(0, fullDeliveryPrice - fsShip). When fully covered, show the free label.
  renderDeliveryPrice(delivery, fullDeliveryPrice, displayedDelivery, fsShip){
    if(!delivery) return;
    const wrapper = delivery.parentElement;
    const freeSpan = wrapper ? wrapper.querySelector('[data-free-delivery]') : delivery.nextElementSibling;
    let original = wrapper ? wrapper.querySelector('.fs-original') : null;
    const hasFsDiscount = fsShip > 0 && fullDeliveryPrice > 0;

    // Struck-through original delivery price, shown only when the free-shipping discount applies.
    if (hasFsDiscount && wrapper) {
      if (!original) {
        original = document.createElement('span');
        original.className = 'fs-original struck-out-price';
        wrapper.insertBefore(original, delivery);
      }
      original.innerText = Theme.Shopify.formatMoney(fullDeliveryPrice, Theme.money_format);
    } else if (original) {
      original.remove();
    }

    // Fully covered -> "Fri levering"; otherwise show the discounted price.
    if (hasFsDiscount && displayedDelivery === 0) {
      delivery.classList.add('d-none');
      if (freeSpan) freeSpan.classList.remove('d-none');
      return;
    }
    delivery.classList.remove('d-none');
    if (freeSpan) freeSpan.classList.add('d-none');
    if (fullDeliveryPrice) delivery.innerText = Theme.Shopify.formatMoney(displayedDelivery, Theme.money_format);
  }

  applyFreeDelivery(delivery){
    delivery.classList.add('struck-out-price');
    delivery.nextElementSibling.classList.remove('d-none');
  }

  removeFreeDelivery(delivery){
    delivery.classList.remove('struck-out-price');
    delivery.nextElementSibling.classList.add('d-none');
  }

  adjustDiscountCodeAmount(discountCodeAmount){
    const cartLineItems = this.container.querySelectorAll('.checkout-order__card[data-is-main="true"] .cart-line__items .cart-line__item');
    if(!cartLineItems) return;
    let freeItemsTotalPrice = 0;
    const cartLineItemsArray = Array.from(cartLineItems);
    cartLineItemsArray.filter(item => {
      if(item.getAttribute('data-item-is-free') === 'true'){
        const itemOriginalTotalPrice = item.getAttribute('data-item-original-total-price');
        freeItemsTotalPrice += parseFloat(itemOriginalTotalPrice);
        return item;
      }
    });
    if(freeItemsTotalPrice >= discountCodeAmount){
      const discountCode = this.container.querySelector('.checkout-order__card[data-is-main="true"] .discount-code');
      this.discountCodeInstance.showErrorMessage('DISCOUNT_NOT_APPLICABLE', "Discount not applicable");
      this.discountCodeInstance.removeDiscount(discountCode);
      return 0;
    }
    else{
      return discountCodeAmount - freeItemsTotalPrice;
    }
  }

  toggleDiscount(discountAmount, discountCode){
    const discountItem = discountCode.closest('.discount-item');
    const automaticDiscountAmount = window.checkout.automaticDiscountAmount || 0;
    const totalDiscountAmount = discountAmount + automaticDiscountAmount;
    
    if(totalDiscountAmount > 0){
      discountItem.classList.remove('d-none');
      discountCode.innerText = `-${Theme.Shopify.formatMoney(totalDiscountAmount, Theme.money_format)}`;
      const labelEl = discountItem.querySelector('[data-checkout-discount-label]');
      if(labelEl){
        const code = window.checkout.manualDiscountCode;
        labelEl.textContent = code ? `${labelEl.dataset.label} (${code})` : labelEl.dataset.label;
      }
    }
    else{
      discountItem.classList.add('d-none');
    }
  }

  async setupTracking() {
    const tracking = new CheckoutTracking();
    await tracking.init();
    tracking.beginCheckout();
  }

}



document.addEventListener('DOMContentLoaded', () => {
    const checkoutContainer = document.querySelector('[data-section-type="checkout-template"]');
    if (checkoutContainer) {
      new Checkout(checkoutContainer);
    }
});

console.log('checkout scripts loaded');